"use client";

import { c as _c } from "react/compiler-runtime";
import styles from "./NextGenToken.module.scss";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { NextGenCollection, NextGenToken, NextGenTrait } from "@/entities/INextgen";
import Link from "next/link";
import { useState } from "react";
import Toggle from "react-toggle";
import { formatNameForUrl } from "@/components/nextGen/nextgen_helpers";
interface Props {
  collection: NextGenCollection;
  token: NextGenToken;
  traits: NextGenTrait[];
  tokenCount: number;
}
export function displayScore(number: number) {
  const precision = 3;
  if (number >= 0.01) {
    return number.toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    });
  }
  if (0.001 > number) {
    return number.toExponential(precision);
  }
  return number.toPrecision(precision);
}
function TraitAccordion(props) {
  const $ = _c(24);
  let t0;
  if ($[0] !== props.title) {
    t0 = <Col xs={5}>{props.title}</Col>;
    $[0] = props.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Col xs={2} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-color-h">Rank:</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.rank) {
    t3 = props.rank.toLocaleString();
    $[4] = props.rank;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Col xs={2} className="text-center">{t2} #{t3}</Col>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="font-color-h">Score:</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props.score) {
    t6 = displayScore(props.score);
    $[9] = props.score;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Col xs={2} className="text-center">{t5}{" "}{t6}</Col>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t0 || $[14] !== t4 || $[15] !== t7) {
    t8 = <Accordion.Button className="d-flex justify-content-between"><Container><Row>{t0}{t1}{t4}{t7}</Row></Container></Accordion.Button>;
    $[13] = t0;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== props.collection || $[18] !== props.token_count || $[19] !== props.traits) {
    t9 = props.traits && <Accordion.Body className={styles.tokenPropertiesAccordionBody}><Container><Row className="pt-2 pb-2"><Col xs={5}>Trait</Col><Col xs={2} className="text-center">Quantity</Col><Col xs={2} className="text-center">Rank</Col><Col xs={2} className="text-center">Score</Col></Row><hr className="mb-1 mt-0" />{props.traits.filter(_temp).map(t_0 => <Row className="pt-2 pb-2" key={`trait-${t_0.trait.replaceAll(" ", "-")}-${t_0.value.replaceAll(" ", "-")}`}><Col xs={5}><span className="font-color-h">{t_0.trait}:</span>{" "}<Link href={`/nextgen/collection/${formatNameForUrl(props.collection.name)}/art?traits=${t_0.trait}:${t_0.value}`}>{t_0.value}</Link></Col><Col xs={2} className="text-center">{t_0.value_count.toLocaleString()} ({(t_0.value_count / props.token_count * 100).toFixed(1)}%)</Col><Col xs={2} className="text-center">{t_0.rank}/{t_0.trait_count}</Col><Col xs={2} className="text-center">{displayScore(t_0.score)}</Col></Row>)}</Container></Accordion.Body>;
    $[17] = props.collection;
    $[18] = props.token_count;
    $[19] = props.traits;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t8}{t9}</Accordion.Item></Accordion>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp(t) {
  return t.score !== -1;
}
export default function NextgenTokenRarity(props) {
  const $ = _c(132);
  const [showNormalised, setShowNormalised] = useState(true);
  const [showTraitCount, setShowTraitCount] = useState(true);
  let t0;
  if ($[0] !== props.token.rarity_score || $[1] !== props.token.rarity_score_normalised || $[2] !== props.token.rarity_score_trait_count || $[3] !== props.token.rarity_score_trait_count_normalised || $[4] !== showNormalised || $[5] !== showTraitCount) {
    t0 = function getRarityScore() {
      if (showNormalised && showTraitCount) {
        return props.token.rarity_score_trait_count_normalised;
      }
      if (showNormalised) {
        return props.token.rarity_score_normalised;
      }
      if (showTraitCount) {
        return props.token.rarity_score_trait_count;
      }
      return props.token.rarity_score;
    };
    $[0] = props.token.rarity_score;
    $[1] = props.token.rarity_score_normalised;
    $[2] = props.token.rarity_score_trait_count;
    $[3] = props.token.rarity_score_trait_count_normalised;
    $[4] = showNormalised;
    $[5] = showTraitCount;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const getRarityScore = t0;
  let t1;
  if ($[7] !== props.token.statistical_score || $[8] !== props.token.statistical_score_normalised || $[9] !== props.token.statistical_score_trait_count || $[10] !== props.token.statistical_score_trait_count_normalised || $[11] !== showNormalised || $[12] !== showTraitCount) {
    t1 = function getStatisticalScore() {
      if (showNormalised && showTraitCount) {
        return props.token.statistical_score_trait_count_normalised;
      }
      if (showNormalised) {
        return props.token.statistical_score_normalised;
      }
      if (showTraitCount) {
        return props.token.statistical_score_trait_count;
      }
      return props.token.statistical_score;
    };
    $[7] = props.token.statistical_score;
    $[8] = props.token.statistical_score_normalised;
    $[9] = props.token.statistical_score_trait_count;
    $[10] = props.token.statistical_score_trait_count_normalised;
    $[11] = showNormalised;
    $[12] = showTraitCount;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const getStatisticalScore = t1;
  let t2;
  if ($[14] !== props.token.single_trait_rarity_score || $[15] !== props.token.single_trait_rarity_score_normalised || $[16] !== props.token.single_trait_rarity_score_trait_count || $[17] !== props.token.single_trait_rarity_score_trait_count_normalised || $[18] !== showNormalised || $[19] !== showTraitCount) {
    t2 = function getSingleTraitRarityScore() {
      if (showNormalised && showTraitCount) {
        return props.token.single_trait_rarity_score_trait_count_normalised;
      }
      if (showNormalised) {
        return props.token.single_trait_rarity_score_normalised;
      }
      if (showTraitCount) {
        return props.token.single_trait_rarity_score_trait_count;
      }
      return props.token.single_trait_rarity_score;
    };
    $[14] = props.token.single_trait_rarity_score;
    $[15] = props.token.single_trait_rarity_score_normalised;
    $[16] = props.token.single_trait_rarity_score_trait_count;
    $[17] = props.token.single_trait_rarity_score_trait_count_normalised;
    $[18] = showNormalised;
    $[19] = showTraitCount;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  const getSingleTraitRarityScore = t2;
  let t3;
  if ($[21] !== props.token.rarity_score_normalised_rank || $[22] !== props.token.rarity_score_rank || $[23] !== props.token.rarity_score_trait_count_normalised_rank || $[24] !== props.token.rarity_score_trait_count_rank || $[25] !== showNormalised || $[26] !== showTraitCount) {
    t3 = function getRarityRank() {
      if (showNormalised && showTraitCount) {
        return props.token.rarity_score_trait_count_normalised_rank;
      }
      if (showNormalised) {
        return props.token.rarity_score_normalised_rank;
      }
      if (showTraitCount) {
        return props.token.rarity_score_trait_count_rank;
      }
      return props.token.rarity_score_rank;
    };
    $[21] = props.token.rarity_score_normalised_rank;
    $[22] = props.token.rarity_score_rank;
    $[23] = props.token.rarity_score_trait_count_normalised_rank;
    $[24] = props.token.rarity_score_trait_count_rank;
    $[25] = showNormalised;
    $[26] = showTraitCount;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  const getRarityRank = t3;
  let t4;
  if ($[28] !== props.token.statistical_score_normalised_rank || $[29] !== props.token.statistical_score_rank || $[30] !== props.token.statistical_score_trait_count_normalised_rank || $[31] !== props.token.statistical_score_trait_count_rank || $[32] !== showNormalised || $[33] !== showTraitCount) {
    t4 = function getStatisticalRank() {
      if (showNormalised && showTraitCount) {
        return props.token.statistical_score_trait_count_normalised_rank;
      }
      if (showNormalised) {
        return props.token.statistical_score_normalised_rank;
      }
      if (showTraitCount) {
        return props.token.statistical_score_trait_count_rank;
      }
      return props.token.statistical_score_rank;
    };
    $[28] = props.token.statistical_score_normalised_rank;
    $[29] = props.token.statistical_score_rank;
    $[30] = props.token.statistical_score_trait_count_normalised_rank;
    $[31] = props.token.statistical_score_trait_count_rank;
    $[32] = showNormalised;
    $[33] = showTraitCount;
    $[34] = t4;
  } else {
    t4 = $[34];
  }
  const getStatisticalRank = t4;
  let t5;
  if ($[35] !== props.token.single_trait_rarity_score_normalised_rank || $[36] !== props.token.single_trait_rarity_score_rank || $[37] !== props.token.single_trait_rarity_score_trait_count_normalised_rank || $[38] !== props.token.single_trait_rarity_score_trait_count_rank || $[39] !== showNormalised || $[40] !== showTraitCount) {
    t5 = function getSingleTraitRarityRank() {
      if (showNormalised && showTraitCount) {
        return props.token.single_trait_rarity_score_trait_count_normalised_rank;
      }
      if (showNormalised) {
        return props.token.single_trait_rarity_score_normalised_rank;
      }
      if (showTraitCount) {
        return props.token.single_trait_rarity_score_trait_count_rank;
      }
      return props.token.single_trait_rarity_score_rank;
    };
    $[35] = props.token.single_trait_rarity_score_normalised_rank;
    $[36] = props.token.single_trait_rarity_score_rank;
    $[37] = props.token.single_trait_rarity_score_trait_count_normalised_rank;
    $[38] = props.token.single_trait_rarity_score_trait_count_rank;
    $[39] = showNormalised;
    $[40] = showTraitCount;
    $[41] = t5;
  } else {
    t5 = $[41];
  }
  const getSingleTraitRarityRank = t5;
  let t6;
  if ($[42] !== showNormalised || $[43] !== showTraitCount) {
    t6 = function getTraitRarityScore(t) {
      if (showNormalised && showTraitCount) {
        return t.rarity_score_trait_count_normalised;
      }
      if (showNormalised) {
        return t.rarity_score_normalised;
      }
      return t.rarity_score;
    };
    $[42] = showNormalised;
    $[43] = showTraitCount;
    $[44] = t6;
  } else {
    t6 = $[44];
  }
  const getTraitRarityScore = t6;
  let t7;
  if ($[45] !== showNormalised || $[46] !== showTraitCount) {
    t7 = function getTraitRarityRank(t_0) {
      if (showNormalised && showTraitCount) {
        return t_0.rarity_score_trait_count_normalised_rank;
      }
      if (showNormalised) {
        return t_0.rarity_score_normalised_rank;
      }
      return t_0.rarity_score_rank;
    };
    $[45] = showNormalised;
    $[46] = showTraitCount;
    $[47] = t7;
  } else {
    t7 = $[47];
  }
  const getTraitRarityRank = t7;
  let t8;
  if ($[48] !== showNormalised) {
    t8 = function getTraitStatisticalScore(t_1) {
      if (showNormalised) {
        return t_1.statistical_rarity_normalised;
      }
      return t_1.statistical_rarity;
    };
    $[48] = showNormalised;
    $[49] = t8;
  } else {
    t8 = $[49];
  }
  const getTraitStatisticalScore = t8;
  let t9;
  if ($[50] !== showNormalised) {
    t9 = function getTraitStatisticalRank(t_2) {
      if (showNormalised) {
        return t_2.statistical_rarity_normalised_rank;
      }
      return t_2.statistical_rarity_rank;
    };
    $[50] = showNormalised;
    $[51] = t9;
  } else {
    t9 = $[51];
  }
  const getTraitStatisticalRank = t9;
  let t10;
  if ($[52] !== showNormalised) {
    t10 = function getTraitSingleRarityScore(t_3) {
      if (showNormalised) {
        return t_3.single_trait_rarity_score_normalised;
      }
      return t_3.statistical_rarity;
    };
    $[52] = showNormalised;
    $[53] = t10;
  } else {
    t10 = $[53];
  }
  const getTraitSingleRarityScore = t10;
  let t11;
  if ($[54] !== showNormalised) {
    t11 = function getTraitSingleRarityRank(t_4) {
      if (showNormalised) {
        return t_4.single_trait_rarity_score_normalised_rank;
      }
      return t_4.statistical_rarity_rank;
    };
    $[54] = showNormalised;
    $[55] = t11;
  } else {
    t11 = $[55];
  }
  const getTraitSingleRarityRank = t11;
  let t12;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Row><Col className="pb-3"><h3 className="mb-0">Rarity</h3></Col></Row>;
    $[56] = t12;
  } else {
    t12 = $[56];
  }
  let t13;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Row><Col><p>Please be careful with rarity in generative collections.</p><p>While it can be an interesting thing to know, many less experienced collectors over-estimate its importance. A piece of generative art can be rare but not aesthetically pleasing. Rarity also does not necessarily correlate to the value of a piece of generative art.</p></Col></Row>;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  let t14;
  if ($[58] !== props.token.name) {
    t14 = <Row className="pt-3 pb-3"><Col className="font-larger font-bolder">{props.token.name}</Col></Row>;
    $[58] = props.token.name;
    $[59] = t14;
  } else {
    t14 = $[59];
  }
  let t15;
  if ($[60] !== showNormalised) {
    t15 = <span className="d-flex align-items-center gap-1"><NextgenRarityToggle title="Trait Normalization" show={showNormalised} setShow={setShowNormalised} /></span>;
    $[60] = showNormalised;
    $[61] = t15;
  } else {
    t15 = $[61];
  }
  let t16;
  if ($[62] !== showTraitCount) {
    t16 = <span className="d-flex align-items-center gap-1"><NextgenRarityToggle title="Trait Count" show={showTraitCount} setShow={setShowTraitCount} /></span>;
    $[62] = showTraitCount;
    $[63] = t16;
  } else {
    t16 = $[63];
  }
  let t17;
  if ($[64] !== t15 || $[65] !== t16) {
    t17 = <span className="d-flex gap-3">{t15}{t16}</span>;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
  } else {
    t17 = $[66];
  }
  let t18;
  if ($[67] !== props.tokenCount) {
    t18 = props.tokenCount.toLocaleString();
    $[67] = props.tokenCount;
    $[68] = t18;
  } else {
    t18 = $[68];
  }
  let t19;
  if ($[69] !== t18) {
    t19 = <span>Token Count: {t18}</span>;
    $[69] = t18;
    $[70] = t19;
  } else {
    t19 = $[70];
  }
  let t20;
  if ($[71] !== t17 || $[72] !== t19) {
    t20 = <Row className="pt-2 pb-2"><Col className="d-flex justify-content-between align-items-center">{t17}{t19}</Col></Row>;
    $[71] = t17;
    $[72] = t19;
    $[73] = t20;
  } else {
    t20 = $[73];
  }
  let t21;
  if ($[74] !== getRarityScore) {
    t21 = getRarityScore();
    $[74] = getRarityScore;
    $[75] = t21;
  } else {
    t21 = $[75];
  }
  let t22;
  if ($[76] !== getRarityRank) {
    t22 = getRarityRank();
    $[76] = getRarityRank;
    $[77] = t22;
  } else {
    t22 = $[77];
  }
  const t23 = props.collection;
  const t24 = props.tokenCount;
  let t25;
  if ($[78] !== getTraitRarityRank || $[79] !== getTraitRarityScore || $[80] !== props.traits) {
    let t26;
    if ($[82] !== getTraitRarityRank || $[83] !== getTraitRarityScore) {
      t26 = t_5 => ({
        trait: t_5.trait,
        value: t_5.value,
        score: getTraitRarityScore(t_5),
        rank: getTraitRarityRank(t_5),
        trait_count: t_5.trait_count,
        value_count: t_5.value_count
      });
      $[82] = getTraitRarityRank;
      $[83] = getTraitRarityScore;
      $[84] = t26;
    } else {
      t26 = $[84];
    }
    t25 = props.traits.map(t26).sort(_temp2);
    $[78] = getTraitRarityRank;
    $[79] = getTraitRarityScore;
    $[80] = props.traits;
    $[81] = t25;
  } else {
    t25 = $[81];
  }
  let t26;
  if ($[85] !== props.collection || $[86] !== props.tokenCount || $[87] !== t21 || $[88] !== t22 || $[89] !== t25) {
    t26 = <Row className="pt-2 pb-2"><Col><TraitAccordion title="Rarity" score={t21} rank={t22} collection={t23} token_count={t24} traits={t25} /></Col></Row>;
    $[85] = props.collection;
    $[86] = props.tokenCount;
    $[87] = t21;
    $[88] = t22;
    $[89] = t25;
    $[90] = t26;
  } else {
    t26 = $[90];
  }
  let t27;
  if ($[91] !== getStatisticalScore) {
    t27 = getStatisticalScore();
    $[91] = getStatisticalScore;
    $[92] = t27;
  } else {
    t27 = $[92];
  }
  let t28;
  if ($[93] !== getStatisticalRank) {
    t28 = getStatisticalRank();
    $[93] = getStatisticalRank;
    $[94] = t28;
  } else {
    t28 = $[94];
  }
  const t29 = props.collection;
  const t30 = props.tokenCount;
  let t31;
  if ($[95] !== getTraitStatisticalRank || $[96] !== getTraitStatisticalScore || $[97] !== props.traits) {
    let t32;
    if ($[99] !== getTraitStatisticalRank || $[100] !== getTraitStatisticalScore) {
      t32 = t_6 => ({
        trait: t_6.trait,
        value: t_6.value,
        score: getTraitStatisticalScore(t_6),
        rank: getTraitStatisticalRank(t_6),
        trait_count: t_6.trait_count,
        value_count: t_6.value_count
      });
      $[99] = getTraitStatisticalRank;
      $[100] = getTraitStatisticalScore;
      $[101] = t32;
    } else {
      t32 = $[101];
    }
    t31 = props.traits.map(t32).sort(_temp3);
    $[95] = getTraitStatisticalRank;
    $[96] = getTraitStatisticalScore;
    $[97] = props.traits;
    $[98] = t31;
  } else {
    t31 = $[98];
  }
  let t32;
  if ($[102] !== props.collection || $[103] !== props.tokenCount || $[104] !== t27 || $[105] !== t28 || $[106] !== t31) {
    t32 = <Row className="pt-2 pb-2"><Col><TraitAccordion title="Statistical Rarity" score={t27} rank={t28} collection={t29} token_count={t30} traits={t31} /></Col></Row>;
    $[102] = props.collection;
    $[103] = props.tokenCount;
    $[104] = t27;
    $[105] = t28;
    $[106] = t31;
    $[107] = t32;
  } else {
    t32 = $[107];
  }
  let t33;
  if ($[108] !== getSingleTraitRarityScore) {
    t33 = getSingleTraitRarityScore();
    $[108] = getSingleTraitRarityScore;
    $[109] = t33;
  } else {
    t33 = $[109];
  }
  let t34;
  if ($[110] !== getSingleTraitRarityRank) {
    t34 = getSingleTraitRarityRank();
    $[110] = getSingleTraitRarityRank;
    $[111] = t34;
  } else {
    t34 = $[111];
  }
  const t35 = props.collection;
  const t36 = props.tokenCount;
  let t37;
  if ($[112] !== getTraitSingleRarityRank || $[113] !== getTraitSingleRarityScore || $[114] !== props.traits) {
    let t38;
    if ($[116] !== getTraitSingleRarityRank || $[117] !== getTraitSingleRarityScore) {
      t38 = t_7 => ({
        trait: t_7.trait,
        value: t_7.value,
        score: getTraitSingleRarityScore(t_7),
        rank: getTraitSingleRarityRank(t_7),
        trait_count: t_7.trait_count,
        value_count: t_7.value_count
      });
      $[116] = getTraitSingleRarityRank;
      $[117] = getTraitSingleRarityScore;
      $[118] = t38;
    } else {
      t38 = $[118];
    }
    t37 = props.traits.map(t38);
    $[112] = getTraitSingleRarityRank;
    $[113] = getTraitSingleRarityScore;
    $[114] = props.traits;
    $[115] = t37;
  } else {
    t37 = $[115];
  }
  let t38;
  if ($[119] !== props.collection || $[120] !== props.tokenCount || $[121] !== t33 || $[122] !== t34 || $[123] !== t37) {
    t38 = <Row className="pt-2 pb-2"><Col><TraitAccordion title="Single Trait Rarity" score={t33} rank={t34} collection={t35} token_count={t36} traits={t37} /></Col></Row>;
    $[119] = props.collection;
    $[120] = props.tokenCount;
    $[121] = t33;
    $[122] = t34;
    $[123] = t37;
    $[124] = t38;
  } else {
    t38 = $[124];
  }
  let t39;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Row><Col /></Row>;
    $[125] = t39;
  } else {
    t39 = $[125];
  }
  let t40;
  if ($[126] !== t14 || $[127] !== t20 || $[128] !== t26 || $[129] !== t32 || $[130] !== t38) {
    t40 = <Container className="no-padding">{t12}{t13}{t14}{t20}{t26}{t32}{t38}{t39}</Container>;
    $[126] = t14;
    $[127] = t20;
    $[128] = t26;
    $[129] = t32;
    $[130] = t38;
    $[131] = t40;
  } else {
    t40 = $[131];
  }
  return t40;
}
function _temp3(a_0, b_0) {
  return b_0.score - a_0.score;
}
function _temp2(a, b) {
  return b.score - a.score;
}
export function NextgenTokenTraits(props) {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col className="pb-3"><h3 className="mb-0">Traits</h3></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.collection || $[2] !== props.traits) {
    let t2;
    if ($[4] !== props.collection) {
      t2 = t => <Row key={`trait-${t.trait.replaceAll(" ", "-")}`}><Col className="pb-3 d-flex gap-2"><span className="font-color-h">{t.trait}:</span><span><Link href={`/nextgen/collection/${formatNameForUrl(props.collection.name)}/art?traits=${t.trait}:${t.value}`}>{t.value}</Link></span><span className="font-color-h">{t.value_count.toLocaleString()}/{t.token_count.toLocaleString()}</span></Col></Row>;
      $[4] = props.collection;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = props.traits.map(t2);
    $[1] = props.collection;
    $[2] = props.traits;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <Container className="no-padding">{t0}{t1}</Container>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function NextgenRarityToggle(props) {
  const $ = _c(18);
  let t0;
  if ($[0] !== props.title) {
    t0 = props.title.replaceAll(" ", "-").toLowerCase();
    $[0] = props.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const label = t0;
  let t1;
  if ($[2] !== props) {
    t1 = () => props.setShow?.(!props.show);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== label || $[5] !== props.disabled || $[6] !== props.show || $[7] !== t1) {
    t2 = <Toggle disabled={props.disabled} id={label} checked={props.show} onChange={t1} />;
    $[4] = label;
    $[5] = props.disabled;
    $[6] = props.show;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = props.disabled ? "font-color-h" : "font-color";
  let t4;
  if ($[9] !== props.title) {
    t4 = <b>{props.title}</b>;
    $[9] = props.title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== label || $[12] !== t3 || $[13] !== t4) {
    t5 = <label htmlFor={label} className={t3}>{t4}</label>;
    $[11] = label;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}